import { PRStatus } from '../constants'

const HKD_CURRENCY = 'HKD'

export const DEFAULT_SOURCING_THRESHOLD = 100000

export const convertAmountToHKD = ({ amount, currency, exchangeRateToHKD }) => {
  const numericAmount = Number(amount)

  if (!Number.isFinite(numericAmount)) {
    return 0
  }

  if (!currency || currency === HKD_CURRENCY) {
    return numericAmount
  }

  const numericRate = Number(exchangeRateToHKD)

  if (!Number.isFinite(numericRate) || numericRate <= 0) {
    return null
  }

  return numericAmount * numericRate
}

export const requiresHSP1Approval = ({ amount, currency, exchangeRateToHKD, threshold }) => {
  const numericThreshold = Number(threshold)
  const effectiveThreshold =
    Number.isFinite(numericThreshold) && numericThreshold > 0 ? numericThreshold : DEFAULT_SOURCING_THRESHOLD

  const amountInHKD = convertAmountToHKD({ amount, currency, exchangeRateToHKD })

  if (amountInHKD === null) {
    return true
  }

  return amountInHKD >= effectiveThreshold
}

const isValidDate = (value) => {
  if (!value) {
    return false
  }

  return !Number.isNaN(new Date(value).getTime())
}

export const getPRSubmissionBlockingReasons = (submission) => {
  const reasons = []

  if (!isValidDate(submission?.expectedDeliveryDate)) {
    reasons.push('Invalid expected delivery date')
  }

  if (!Array.isArray(submission?.approverDetails) || submission.approverDetails.length === 0) {
    reasons.push('Missing PR approver details')
    return reasons
  }

  submission.approverDetails.forEach((approverDetail) => {
    const approverType = approverDetail?.type ?? 'approver'

    if (!approverDetail?.user) {
      reasons.push(`Missing approver user for ${approverType}`)
    }

    if (!isValidDate(approverDetail?.dueDate)) {
      reasons.push(`Missing approver due date for ${approverType}`)
    }
  })

  return reasons
}

export const DraftSubmissionType = {
  GCPR: 'GCPR',
  PR: 'PR',
}

export const collectDraftGCPRSubmissions = (GCMaterialSubmissions) => {
  if (!Array.isArray(GCMaterialSubmissions)) {
    return []
  }

  return GCMaterialSubmissions.map((submission, submissionIndex) => ({
    type: DraftSubmissionType.GCPR,
    submissionIndex,
    submission,
  })).filter(({ submission }) => submission?.status === PRStatus.DRAFT)
}

export const collectDraftPRSubmissions = (costBudgets) => {
  if (!Array.isArray(costBudgets)) {
    return []
  }

  const draftSubmissions = []

  costBudgets.forEach((costBudget, costBudgetIndex) => {
    const vendorSelections = costBudget?.PR?.vendorSelections

    if (!Array.isArray(vendorSelections)) {
      return
    }

    vendorSelections.forEach((vendorSelection, vendorSelectionIndex) => {
      const submissions = vendorSelection?.submissions

      if (!Array.isArray(submissions)) {
        return
      }

      submissions.forEach((submission, submissionIndex) => {
        if (submission?.status !== PRStatus.DRAFT) {
          return
        }

        draftSubmissions.push({
          type: DraftSubmissionType.PR,
          costBudgetIndex,
          vendorSelectionIndex,
          submissionIndex,
          submission,
        })
      })
    })
  })

  return draftSubmissions
}
